<template>
  <div
    class="slider-container"
    v-bind:style="{ 'min-height': viewHeight ? viewHeight : '500px' }"
  >
    <div class="photo">
      <avatar></avatar>
      <div v-if="!isSmallDisplay" class="white--text">
        <p>
          RE/MAX 2023年加州排名第13<br />
          RE/MAX 2023年全美排名第41<br />
          RE/MAX 传奇人物奖<br />
          RE/MAX 全球1%强排行榜房地产经纪人<br />
          洛杉矶五星房地产经纪人
          <!-- 2020年销售额: 14094500美元 -->
        </p>
        <!-- <a itemprop="telephone" href="tel:001-626-390-8870" style="color:white">
          <v-icon color="white" size="18">fas fa-phone</v-icon>
          <span class="pl-2">626-390-8870</span></a> -->
      </div>
    </div>
    <!-- <span class="sale-label">在售</span> -->
    <v-carousel
      :height="viewHeight < viewWidth ? viewHeight : viewWidth * 0.66"
      v-model="carouselIndex"
      hide-delimiters
      :show-arrows="false"
      cycle
      :vertical="viewWidth > viewHeight"
    >
      <v-carousel-item v-for="(item, i) in properties" :key="i">
        <v-img
          :lazy-src="imgPath + item.id + '/thumbs/' + item.img"
          :src="imgPath + item.id + '/' + item.img"
          :width="viewWidth"
          :height="viewWidth < viewHeight ? 'auto' : viewHeight"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-carousel-item>
    </v-carousel>
    <div class="slider-banner">
      <div class="slider-title">
        {{ properties[carouselIndex].title }}<br />
        {{ formatPrice(properties[carouselIndex].price) }}
      </div>
      <div class="banner-button center">
        <v-btn small fab @click="goToListing()">
          <v-icon small color="pink">fas fa-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <v-row>
      <v-col>
        <v-card>
          <v-container grid-list-sm fluid>
            <v-row>
              <v-col
                v-for="p in propertiesPics"
                :key="p"
                cols="4"
                class="d-flex"
              >
                <div class="center listing-card" style="overflow: hidden">
                  <v-card flat tile class="d-flex">
                    <v-img
                      :lazy-src="imgPath + currentPropertyId + '/thumbs/' + p"
                      :src="imgPath + currentPropertyId + '/' + p"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Utils } from "../../utils";
import Avatar from "../../components/Avatar";

// const MAX_PIC = 3

export default {
  name: "property-slider",
  components: {
    Avatar,
  },
  computed: {
    ...mapState({
      viewWidth: (state) => state.homeStore.viewWidth,
      viewHeight: (state) => state.homeStore.viewHeight - 60,
      isSmallDisplay: (state) => state.homeStore.isSmallDisplay,
      storeProperties: (state) =>
        state.listingStore.properties.filter(
          (e) => !e.sold && !e.leased && e.preview
        ),
    }),
    currentPropertyId: {
      get() {
        return this.properties[this.carouselIndex].id;
      },
      set(val) {},
    },
    currentPropertyIdx: {
      get() {
        return this.properties[this.carouselIndex].propIdx;
      },
      set(val) {},
    },
    propertiesPics: {
      get() {
        // if(this.storeProperties[this.currentPropertyIdx].picsWithTitle){
        //   let pics = []
        //   this.storeProperties[this.currentPropertyIdx].picsWithTitle.forEach((p, idx) => {
        //     if( idx < MAX_PIC )
        //     pics.push(p.pic)
        //   })
        //   return pics
        // }
        return this.storeProperties[this.currentPropertyIdx].preview;
      },
      set(val) {},
    },
  },
  data() {
    return {
      imgPath: "http://www.juliazhao.com/realestate/properties/",
      carouselHeight: 0,
      carouselIndex: 0,
      properties: null,
    };
  },
  created() {
    this.properties = this.getProperties();
  },
  methods: {
    getProperties() {
      let picData = [];
      this.storeProperties.forEach((e, i) => {
        // if( e.picsWithTitle ) {
        //   e.picsWithTitle.forEach((p, idx) => {
        //     if( idx < MAX_PIC ){
        //     picData.push({propIdx: i, id: e.id, title: e.title, price: e.price, img: p.pic})
        //     }
        //   })
        // } else {
        e.preview.forEach((pic) => {
          if (!e.sold)
            picData.push({
              propIdx: i,
              id: e.id,
              title: e.title,
              price: e.price,
              img: pic,
            });
        });
        // }
      });
      this.currentPropertyId = picData[0].id;
      return picData;
    },
    formatPrice: function (price) {
      return Utils.getPriceTxt(price, true);
    },
    goToListing() {
      this.$router.push("listing");
    },
    isSmartphone() {
      return this.viewWidth < 600 || this.viewHeight < 600;
    },
  },
};
</script>

<style scoped>
@import "../PropertyCarousel.css";
</style>
